import { StyledTableWrapper } from "src/styled";

import AddDynamicRow from "./_AddDynamicRow";
import DeleteDynamicRow from "./_DeleteDynamicRow";
import Row from "./_Row";
import { type ILandscapeSection } from "./landscape.types";

interface Props extends ILandscapeSection {
  sectionIndex: number;
  subSectionIndex: number;
  dynamicRows?: boolean;
  cloneRows?: boolean;
  copyPrevVal?: number;
  enterNavigation?: "down" | "next";
}

const LandscapeSection = ({
  rows,
  dynamicRows,
  cloneRows,
  copyPrevVal,
  enterNavigation,
  ...indexes
}: Props) => {
  return (
    <StyledTableWrapper data-enter-navigation={enterNavigation}>
      <table>
        <DeleteDynamicRow rows={rows} {...indexes} />
        {rows.map(
          (row, idx) =>
            row && (
              <Row {...row} {...indexes} rowIndex={idx} key={`row-${idx}`} />
            ),
        )}
        <DeleteDynamicRow rows={rows} {...indexes} />
      </table>
      {dynamicRows && (
        <AddDynamicRow
          {...indexes}
          cloneRows={cloneRows}
          copyPrevVal={copyPrevVal}
        />
      )}
    </StyledTableWrapper>
  );
};
export default LandscapeSection;
